const $accordion = $('.js-accordion');

const accordion = {
  initialize(element: HTMLElement) {
    this.element = element;
    this.$element = $(this.element);

    this.$element.on('click', '.js-accordion-trigger', this.openItem.bind(this));
  },

  openItem(event) {
    event.preventDefault();

    const $currentTrigger = $(event.currentTarget);
    const isOpen = $currentTrigger.attr('aria-expanded') === 'true';

    this.closeAllItems();

    if (isOpen) {
      return;
    }

    const $item = $currentTrigger.parents('.js-accordion-item');

    if (!$item.length) {
      return;
    }

    $currentTrigger.attr('aria-expanded', 'true');

    const $body = $item.find('.js-accordion-body');

    $body.attr('aria-hidden', 'false');
  },

  closeAllItems() {
    this.$element.find('.js-accordion-trigger').toArray().forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    this.$element.find('.js-accordion-body').toArray().forEach((body) => {
      body.setAttribute('aria-hidden', 'true');
    });
  },
};

export default {
  initialize() {
    $accordion.toArray().forEach((accordionElement) => {
      Object.assign({}, accordion).initialize(accordionElement);
    });
  },
};
